import { faker } from '@faker-js/faker';
import {
  PData,
  PaymentDetailsDTO,
  Trandata,
} from '../openapi/models/PaymentDetailsDTO';

export const generateMockPaymentDetails: () => PaymentDetailsDTO = () => ({
  oper_id: -1,
  order_id: faker.string.uuid(),
  receipt_id: faker.string.uuid(),
  partner_id: faker.number.int(),
  partner_name: faker.company.name(),
  partner_key: faker.string.alphanumeric(16),
  create_dtime: faker.date.recent().toISOString(),
  status: 3,
  status_desc: 'success',
  req_amount: parseInt(faker.finance.amount()) * 100,
  req_fee: parseInt(faker.finance.amount()) * 100,
  currency: faker.finance.currencyCode(),
  backref_url: faker.internet.url(),
  notify_url: faker.internet.url(),
  lang: 'ua',
  lifetime: faker.number.int({min: 1, max: 100}),
  card_name: faker.finance.creditCardNumber('visa'),
  card_type: 2,
  tool_name: faker.lorem.word(),
  approval_code: faker.string.alphanumeric(6),
  rrn: faker.string.alphanumeric(12),
  partner_data: faker.lorem.words(),
  acq_name: faker.company.name(),
  api_ver: '1',
  user_id: faker.string.uuid(),
  user_phone: faker.phone.number(),
  user_email: faker.internet.email(),
  user_name: faker.person.fullName(),
  acq_trans_id: faker.string.alphanumeric(12),
  acq_dtime: faker.date.recent().toISOString(),
  issuer_name: faker.company.name(),
  user_ip: faker.internet.ipv4(),
  pan_masked: faker.finance.creditCardNumber('visa'),
  recur_id: faker.number.int(),
  repeat_num: faker.number.int(),
  // recur_period: faker.lorem.word(),
  // recur_amount: faker.finance.amount(),
  start_dtime: faker.date.recent().toISOString(),
  stop_dtime: faker.date.recent().toISOString(),
  pdata: [...Array(3)].map(() => ({
    point_id: faker.number.int({min: 1, max: 100}),
    point_name: faker.lorem.word(),
    amount: parseInt(faker.finance.amount()) * 100,
    fee: parseInt(faker.finance.amount()) * 100,
    pay_descr: faker.lorem.words(),
  })) as PData[],
  trandata: [...Array(3)].map(() => ({
    point_id: faker.number.int({min: 1, max: 100}),
    point_name: faker.lorem.word(),
    amount_change: parseInt(faker.finance.amount({min: -1000})) * 100,
    change_dtime: faker.date.recent().toISOString(),
  })) as Trandata[],
});

// Пример использования
export const mockPaymentDetails: PaymentDetailsDTO =
  generateMockPaymentDetails();
